import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-base font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {t('siteName')}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{t('siteTagline')}</p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">{t('nav.allCategories')}</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">{t('nav.about')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  {t('about.brandIntro')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  {t('about.reputation')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  {t('about.contactTitle')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">法律信息</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors" rel="nofollow">
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors" rel="nofollow">
                  {t('footer.terms')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">{t('footer.copyright').replace('2024', String(currentYear))}</p>
            <p className="text-xs text-foreground-500">{t('footer.disclaimer')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}